<template>
    <header id="home-header">
        <div class="home-header bg-primary">
            <div class="container">
                <div class="row">
                    <div class="col-6 text-right">
                        <div class="v-center">
                          <span class="logo"><img alt="logo" class="logo-img" src="../assets/logo.png"></span>
                          <div v-bind:class="{'two-line-title': NakdanType.Pro}">
                            <span class="title-text text-white">נקדן
                            </span>
                          </div>
                        </div>
                    </div>
                    <div class="col-6 left-items">
                        <a class="genre-setter ml-1" href="#" @click="genreSetterClicked">סגנון: {{ chosenGenreDisplayText }}</a>
                    </div>
                </div>
            </div>
        </div>
        <mobile-genre-popup :show-mobile-genre-popup="showMobileGenrePopup" />
    </header>
</template>
<script>
import MobileGenrePopup from './MobileGenrePopup'
import {NakdanType} from '@/simpleVsProConfig.js'

const textTypes = [
  {
    name: 'modern',
    displayText: 'מודרני'
  },
  {
    name: 'rabbinic',
    displayText: 'רבני'
  },
  {
    name: 'poetry',
    displayText: 'שירה'
  }
]

export default {
  components: {
      MobileGenrePopup
  },
  name: 'MobileHomeHeader',
  data () {
    return {
      showMobileGenrePopup: false,
    }
  },
  computed: {
    NakdanType () {
        return NakdanType
    },
    chosenGenreDisplayText () {
      const chosenTextTypeIndex = textTypes.map(t => t.name).indexOf(this.$store.state.preSubmissionOptions.chosenTextTypeName)
      return textTypes[chosenTextTypeIndex].displayText
    }
  },
  methods: {
    genreSetterClicked () {
      this.showMobileGenrePopup = false // because the modal reacts to CHANGE in showMobileGenrePopup
      setTimeout(() => {
        this.showMobileGenrePopup = true
      }, 100)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .home-header {
    height: 50px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
    display: flex;
    align-items: center;
  }

  .logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    background-color: white;
    margin: 0 0 0 10px;
  }

  .logo-img {
    margin-top: 1px;
    width: 18px;
  }

  .v-center {
    display: flex;
    align-items: center;
  }

  .left-items {
      display: flex;
      align-items: center;
      justify-content: flex-end;
  }

  .genre-setter {
      color: white;
      text-decoration: underline;
  }

  /* settings below here are used only by the 'Pro' Nakdan */
  .two-line-title {
    line-height: 1.15rem;
  }

  .text-light {
    color: #d6ecff !important;
    font-size: 0.75rem;
  }
</style>
